import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { RolodexContactFormPresentation } from './rolodex-contact-form-presentation';
import { RolodexContactFormVM } from './rolodex-contact-form.viewmodel';
import { IntlShape } from 'react-intl';
import { IRolodexContactDTO } from '../../../../../api/rolodex.dao';

import './rolodex-contact-form.scss';

interface IRolodexContactFormProps {
    contactId: number;
    intl: IntlShape;
    saveCompletedCallback: (contact: IRolodexContactDTO) => void;
}

export const RolodexContactForm = withViewModel(
    RolodexContactFormPresentation,
    async ({
        contactId,
        intl,
        saveCompletedCallback,
    }: IRolodexContactFormProps) => {
        const vm = new RolodexContactFormVM(
            contactId,
            intl,
            saveCompletedCallback,
        );
        await vm.initialize();
        return vm;
    }
);
